import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { Router } from '@angular/router';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { Location } from '@angular/common';
import { NgxColorsModule } from 'ngx-colors';
import { AppointmentSearchComponent } from '../../Front-end/appointment-search/appointment-search.component';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
 loading=false;
  registerForm:FormGroup;
  currentUser: User;
  username;
branch;
success;
error;
branchCategories=[];
roleCategories=[];

expertise;//=['Slabs', 'Cut to size', 'Wood', 'Ciot Studio', 'Ceramic and Porcelain Tiles', 'Stone Tiles', 'Installation/Maintenance Product'];
  validationMessages = {
    'firstName': {
      'required': 'First Name is required'
    },
    'lastName': {
      'required': 'Last Name is required'
    },

    'branch': {
      'required': 'Branch is required'
    },
    'role': {
      'required': 'Role is required'
    },
    'userID': {
      'required': 'Date of birth is required'
    },
   
  };


  formErrors = {
    'firstName': '',
    'lastName': '',
    'branch': '',
    'userID': '',
    'role': '',
  };

  constructor(private fb: FormBuilder,
    private router: Router,
    private _location: Location,
    private _appointmentService: AppointmentService,
    private _authenticationService: AuthenticationService)
    {}

  ngOnInit(): void {
    this.getRoleCategoriesForForm()
    this.getBranchCategoriesForForm();
   // this.getUserExpertiseForForm();
    
    console.log(this._authenticationService.currentUserValue.userName)
    
    this.registerForm = this.fb.group({
      actionPerformedBy:new FormControl(this._authenticationService.currentUserValue.userName),
      pid: new FormControl(''),
      firstName: new FormControl('', [Validators.required]),
      middleName: new FormControl(''),
      lastName: new FormControl(''),
      email: new FormControl(''),
      userID: new FormControl(''),
      branch: new FormControl(''),
      role: new FormControl(''),
      color: new FormControl(''),
      expertise: this.fb.array([])
      //purchaseDate: new FormControl(''),
    });



  

    //error handling
    this.registerForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.registerForm);
    })
  }


  getUserExpertiseForForm() {
   
this._appointmentService.getUserExpertiseForForm()
        .subscribe(//subscribe to Observable
          response => {
            console.log('Success!', response);
            this.expertise = response;
         
          },
          error => {
            console.error('ERROR!', error);
            this.error = error;
            document.getElementById("openErrorModalButton").click();
          }
        );
  }



  getUserExpertiseForFormByLocation(branch) {
   console.log(branch);
   var locationID="";
   this.branchCategories.forEach(x=>{
    if(x.name==branch){
locationID=x.locationID;

    }
   })
   console.log(locationID)
    this._appointmentService.getUserExpertiseForFormByLocation(locationID)
            .subscribe(//subscribe to Observable
              response => {
                console.log('Success!', response);
                this.expertise = response;
             
              },
              error => {
                console.error('ERROR!', error);
                this.error = error;
                document.getElementById("openErrorModalButton").click();
              }
            );
      }
    
    
      resgisterUser() {
        this.logValidationErrors(this.registerForm);
      
        this._authenticationService.register(this.registerForm.value)
          .subscribe({
            next: (response) => {
              console.log('Success!', response);
              this.success = response['SUCCESS'];
              this.registerForm.reset();
              document.getElementById("openSuccessModalButton")?.click();
            },
            error: (error) => {
              console.error('Error object received in registerUser:', error.error.ERROR);
      
              // Adjust based on where the error message is located
              // Example if error message is directly in `error`:
              if (error?.error?.ERROR) {
                console.log('Error message:', error.error.ERROR);  // Expecting: "User Name already exists"
              } else if (typeof error === 'string') {
                console.log('Error message:', error);  // If handleError returned a string
              } else {
                console.log('Unexpected error structure:', error);  // For any other structure
              }
      
              document.getElementById("openErrorModalButton")?.click();
            }
          });
      }

  
registerUser(){
  this.logValidationErrors(this.registerForm);
  this.loading=true;
  this._authenticationService.register(this.registerForm.value)
        .subscribe(//subscribe to Observable
          response => {
            console.log('Success!', response);
            this.success = response['SUCCESS'];
            this.registerForm.reset;
            document.getElementById("openSuccessModalButton").click();
            this.loading=false;
          },
          error => {
            this.loading=false;
            console.log(error);
           // if (error.error && error.error.ERROR) {
             // console.log(error.error.ERROR); // "User Name already exists"
              this.error=error;
            
           
            document.getElementById("opennErrorModalButton").click();
            //}
          }
        );

}

  
backClicked() {
  this._location.back();
}

  logValidationErrors(group: FormGroup ): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
              console.log(key);

              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }

  getRoleCategoriesForForm(){
    this._authenticationService.getRoleCategoriesForForm().subscribe(
      (res) => {
  
        this.roleCategories = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }


getBranchCategoriesForForm(){
  this._authenticationService.getBranchCategoriesForForm().subscribe(
    (res) => {

      this.branchCategories = res;
      console.log(this.branchCategories);
    },
    (err) => {
      this.error = err;
    }
  );
}



onExpertiseChange(expert, event: any) {
  console.log(expert);
  const expertise = this.registerForm.get('expertise') as FormArray;
  if (event.target.checked) {
    expertise.push(this.fb.control(expert));
  } else {
    const index = expertise.controls.findIndex(x => x.value === expert);
    expertise.removeAt(index);
  }
}

}
